import { render } from "./SignDocuments.vue?vue&type=template&id=015be650&scoped=true"
import script from "./SignDocuments.vue?vue&type=script&lang=js"
export * from "./SignDocuments.vue?vue&type=script&lang=js"

import "./SignDocuments.vue?vue&type=style&index=0&id=015be650&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015be650"]])

export default __exports__